<template>
  <div class="medaiPreview" v-if="visible" @click="close">
    <div class="audioPreview" v-if="fileType == 'audio'">
      <div class="addAudio" @click.stop="">
        <audio controls class="audio-prediv" :ref="`audio_player`" :src="$tool.getImageParam(fileUrl)"></audio>
      </div>
    </div>
    <div class="videoPreview" v-else-if="fileType == 'video'">
      <video :src="$tool.getImageParam(fileUrl)" controls="controls" v-if="fileUrl" class="video-prediv" @click.stop=""></video>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      fileUrl: '',
      fileType: '',
    };
  },
  methods: {
    close() {
      this.visible = false;
      let cleardom = document.body.querySelectorAll('.medaiPreview');
      Array.from(cleardom).forEach((item) => {
        item.remove();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.picturePreview,
.audioPreview,
.videoPreview {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .previewImg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-height: 100vh;
    max-width: 100vw;
  }
  .audio-prediv,
  .video-prediv {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-height: 75%;
    max-width: 75%;
  }
}
</style>
